import { IconBrandMyOppo, IconBuildingStore, IconCalendarEvent, IconCategory, IconCategory2, IconHeartDiscount, IconHome, IconLogout, IconMailX, IconMapPinQuestion, IconMapQuestion, IconMoneybag, IconPackage, IconRecharging, IconSettings, IconSpeedboat, IconStars, IconTicket, IconTruckReturn, IconUserQuestion, IconUsersGroup, IconUserStar } from "@tabler/icons-react";
import $ from "jquery";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo2.png";
import { logout } from "../../redux/slice/authSlice";
import { closeDialog } from "../../redux/slice/dialogueSlice";
import { warning } from "../../util/Alert";
import { projectName } from "../../util/config";
import Navigator from "../extras/Navigator";
const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const data = warning("Logout");
    data
      .then((logouts) => {
        const yes = logouts.isConfirmed;
        console.log("yes", yes);
        if (yes) {
          dispatch(logout());
          navigate("/");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleOnClick = () => {
    sessionStorage.removeItem("dialog");
    dispatch(closeDialog());
  };

  const navBarArray = [
    {
      name: "Dashboard",
      path: "/admin/adminDashboard",
      navIcon : <IconHome/>,
      activeArrList: ["/admin/adminDashboard", "/admin/mainDashboard"],
    },
  ];

  const array2 = [
    {
      name: "Salon",
      path: "/admin/allSalon",
      navIcon : <IconBuildingStore/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/allSalon", "/admin/allSalon/schedule" , "/admin/salon/bookings" , "/admin/salon/orders" ,"/admin/salon/salonProfile" , "/admin/salon/income"],
    },
    {
      name: "Expert",
      path: "/admin/allExperts",
      navIcon : <IconUserStar/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/allExperts" , "/admin/expert/bookings" , "/admin/expert/getExpertProfile" , "/admin/particularExpert/income"],
    },
    {
      name: "Customer",
      path: "/admin/userTable",
      navIcon : <IconUsersGroup/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/userTable" , "/admin/user/bookings" , "/admin/user/userProfile"],
    },
    {
      name: "Reviews",
      path: "/admin/reviewTable",
      navIcon : <IconStars/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/reviewTable"],
    },
    {
      name: "Complain",
      path: "/admin/complainTable",
      navIcon : <IconMailX/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/complainTable"],
    },
    {
      name: "Expert attendance",
      path: "/admin/attendanceTable",
      navIcon : <IconCalendarEvent/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/attendanceTable"],
    },
  ];
  const array10 = [
    {
      name: "Withdraw Request",
      navIcon : <IconUserQuestion/>,
      activeArrList: ["/admin/withdrawRequest" , "/admin/expertRequest"],
      subMenu: [
        {
          subName: "Salon",
          subPath: "/admin/withdrawRequest",
        },
        {
          subName: "Expert",
          subPath: "/admin/expertRequest",
        },
      ]
      // onClick: handleOnClick,
    },
  ]

  const array6 = [
    {
      name: "Bookings",
      navIcon : <IconTicket/>,
      activeArrList: ["/admin/bookingTable" , "/admin/dailyBookingTable" ,"/admin/monthlyReport"],
      subMenu: [
        {
          subName: "All Bookings",
          subPath: "/admin/bookingTable",
        },
        {
          subName: "Daily Bookings",
          subPath: "/admin/dailyBookingTable",
        },
        {
          subName: "Monthly Report",
          subPath: "/admin/monthlyReport",
        },
      ],
    },
  ];
  const array7 = [
    // {
    //   name: "Attribute",
    //   path: "/admin/productAttributes",
    //   navSVG: (
    //     <Services height={20} width={20} style={{ color: "gray" }} />
    //   ),
    //   onClick: handleOnClick,
    // },
    {
      name: "Product",
      path: "/admin/productTable",
      navIcon : <IconPackage/>,
      activeArrList: ["/admin/productTable" , "/admin/product/productTableDetails"],
    },
    {
      name: "Product category",
      path: "/admin/productCategoryTable",
      navIcon : <IconCategory/>,
      activeArrList: ["/admin/productCategoryTable" ],
    },

  ];
  const array8 = [
    {
      name: "Product Request",
      navIcon: <IconMapQuestion/>,
      activeArrList: ["/admin/pendingProduct" , "/admin/approvedProduct" , "/admin/rejectedProduct" ],
      subMenu: [
        {
          subName: "Pending",
          subPath: "/admin/pendingProduct",
          activeArrList: ["/admin/product/productTableDetails" , "/admin/pendingProduct"],
        },
        {
          subName: "Approved",
          subPath: "/admin/approvedProduct"
        },
        {
          subName: "Rejected",
          subPath: "/admin/rejectedProduct"
        },
      ]
    },
  ];
  const array9 = [
    {
      name: "Order",
      path: "/admin/orderTable",
      navIcon : <IconTruckReturn/>,
      activeArrList: ["/admin/orderTable" , "/admin/order/orderDetails"],
    },
  ];
  const array3 = [
    {
      name: "Category",
      path: "/admin/categoryTable",
      navIcon : <IconCategory2/>,
      activeArrList: ["/admin/categoryTable"],
    },
    {
      name: "Services",
      path: "/admin/serviceTable",
      navIcon : <IconBrandMyOppo/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/serviceTable"],
    },
  ];

  const array4 = [
    {
      name: "Coupon",
      path: "/admin/coupon",
     navIcon : <IconHeartDiscount/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/coupon"],
    },
    {
      name: "User Recharge",
      path: "/admin/recharge",
      navIcon : <IconRecharging/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/recharge"],
    },
    {
      name: "Expert earnings",
      path: "/admin/staffEarning",
      navIcon : <IconMoneybag/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/staffEarning"],
    },
    
    // {
    //   name: "Salon-Earnings",
    //   path: "/admin/salonPayment",
    //   navSVG: (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M19.8974 1H4.10256C3.2799 1.0006 2.49109 1.32767 1.90938 1.90938C1.32767 2.49109 1.0006 3.2799 1 4.10256V8.61539C1.0006 9.43805 1.32767 10.2269 1.90938 10.8086C2.49109 11.3903 3.2799 11.7174 4.10256 11.7179H5.51282V19.8974C5.51342 20.7201 5.84049 21.5089 6.4222 22.0906C7.00391 22.6723 7.79272 22.9994 8.61539 23H15.3846C16.2073 22.9994 16.9961 22.6723 17.5778 22.0906C18.1595 21.5089 18.4866 20.7201 18.4872 19.8974V11.7179H19.8974C20.7201 11.7174 21.5089 11.3903 22.0906 10.8086C22.6723 10.2269 22.9994 9.43805 23 8.61539V4.10256C22.9994 3.2799 22.6723 2.49109 22.0906 1.90938C21.5089 1.32767 20.7201 1.0006 19.8974 1ZM16.7949 19.8974C16.7949 20.6748 16.1619 21.3077 15.3846 21.3077H8.61539C7.83805 21.3077 7.20513 20.6748 7.20513 19.8974V7.20513H16.7949V19.8974ZM21.3077 8.61539C21.3077 9.39272 20.6748 10.0256 19.8974 10.0256H18.4872V7.20513H18.7692C18.9936 7.20513 19.2089 7.11598 19.3676 6.9573C19.5262 6.79861 19.6154 6.58339 19.6154 6.35897C19.6154 6.13456 19.5262 5.91934 19.3676 5.76065C19.2089 5.60197 18.9936 5.51282 18.7692 5.51282H5.23077C5.00636 5.51282 4.79113 5.60197 4.63245 5.76065C4.47376 5.91934 4.38462 6.13456 4.38462 6.35897C4.38462 6.58339 4.47376 6.79861 4.63245 6.9573C4.79113 7.11598 5.00636 7.20513 5.23077 7.20513H5.51282V10.0256H4.10256C3.32523 10.0256 2.69231 9.39272 2.69231 8.61539V4.10256C2.69231 3.32523 3.32523 2.69231 4.10256 2.69231H19.8974C20.6748 2.69231 21.3077 3.32523 21.3077 4.10256V8.61539ZM8.89744 13.1282V10.8718C8.89744 10.6474 8.98658 10.4322 9.14527 10.2735C9.30395 10.1148 9.51918 10.0256 9.74359 10.0256C9.968 10.0256 10.1832 10.1148 10.3419 10.2735C10.5006 10.4322 10.5897 10.6474 10.5897 10.8718V13.1282C10.5897 13.3526 10.5006 13.5678 10.3419 13.7265C10.1832 13.8852 9.968 13.9744 9.74359 13.9744C9.51918 13.9744 9.30395 13.8852 9.14527 13.7265C8.98658 13.5678 8.89744 13.3526 8.89744 13.1282ZM8.89744 18.7692V16.5128C8.89744 16.2884 8.98658 16.0732 9.14527 15.9145C9.30395 15.7558 9.51918 15.6667 9.74359 15.6667C9.968 15.6667 10.1832 15.7558 10.3419 15.9145C10.5006 16.0732 10.5897 16.2884 10.5897 16.5128V18.7692C10.5897 18.9936 10.5006 19.2089 10.3419 19.3676C10.1832 19.5262 9.968 19.6154 9.74359 19.6154C9.51918 19.6154 9.30395 19.5262 9.14527 19.3676C8.98658 19.2089 8.89744 18.9936 8.89744 18.7692Z"
    //         fill="#818185"
    //       />
    //     </svg>
    //   ),
    //   onClick: handleOnClick,
    // },
  ];
  const array5 = [
    // {
    //   name: "Salon Reports",
    //   navIcon: "ri-money-dollar-box-line",
    //   onClick: handleOnClick,
    //   subMenu: [
    //     {
    //       subName: "Payment History",
    //       subPath: "/admin/yearlyPayment",
    //     }
    //   ],
    // },

    {
      name: "Salon Holiday",
    navIcon : <IconSpeedboat/>,
      path: "/admin/holiday",
      onClick: handleOnClick,
      activeArrList: ["/admin/holiday"],
    },
    
    {
      name: "Salon Request",
      navIcon : <IconMapPinQuestion/>,
      path: "/admin/salonRequest",
      onClick: handleOnClick,
      activeArrList: ["/admin/salonRequest"],
    },
    
    {
      name: "Setting",
      path: "/admin/settingPage",
      navIcon : <IconSettings/>,
      onClick: handleOnClick,
      activeArrList: ["/admin/settingPage"],
    },

    {
      name: "Logout",
      navIcon : <IconLogout/>,
      onClick: handleLogout,
    },
  ];

  var webSize = $(window).width();

  const [totalPage, setTotalPage] = useState(20);

  return (
    <>

      <SideMenuJS  totalPage={totalPage}/>
    <div className="mainSidebar">
      <div className="sideBar webSidebar">
        <div className="sideBarLogo">
            <Link
              to={"/admin/mainDashboard"}
              className="d-flex align-items-center cursor-pointer"
            >
              <img src={logo} alt="" width={"35px"} />
              <span
                className="fs-4 fw-semibold"
                style={{ color: "rgb(47 43 61 / 0.9)" }}
              >
                {projectName}
              </span>
            </Link>
          </div>
        
        <div className="navigation">
          
              <p className="sideBarTitle sidebar-title">Menu</p>
              <nav
              style={{
                background: "white",
                borderRadius: "10px",
                color: "#404040",
              }}
            >

              {navBarArray?.length > 0 && (
                <>
                  {(totalPage > 0
                    ? navBarArray.slice(0, totalPage)
                    : navBarArray
                  ).map((res) => {
                    return (
                      <>
                        <Navigator
                          name={res?.name}
                          path={res?.path}
                          activeArrList={res?.activeArrList}
                          path2={res?.path2}
                          navIcon={res?.navIcon}
                          navIconImg={res?.navIconImg}
                          navSVG={res?.navSVG}
                          onClick={res?.onClick && res?.onClick}
                        >
                          {res?.subMenu &&
                            res?.subMenu?.map((subMenu) => {
                              return (
                                <Navigator
                                  subName={subMenu.subName}
                                  subPath={subMenu.subPath}
                                  subPath2={subMenu.subPath2}
                                  onClick={subMenu.onClick}
                                />
                              );
                            })}
                        </Navigator>
                      </>
                    );
                  })}
                </>
              )}
            </nav>

              <p className="sideBarTitle sidebar-title">User</p>
              <nav
              style={{
                background: "white",
                borderRadius: "10px",
                color: "#404040",
              }}
            >
              {array2.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                          path={res?.path}
                          path2={res?.path2}
                          activeArrList={res?.activeArrList}
                          navIcon={res?.navIcon}
                          navIconImg={res?.navIconImg}
                          navSVG={res?.navSVG}
                          onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          }
                      )}
                    </Navigator>
                  </>
                );
              })}

            </nav>

              <p className="sideBarTitle sidebar-title">Services</p>
              <nav
              style={{
                background: "white",
                borderRadius: "10px",
                color: "#404040",
              }}
            >

              {array3.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}
            </nav>

              <p className="sideBarTitle sidebar-title">E-commerce</p>
              <nav
              style={{
                background: "white",
                borderRadius: "10px",
                color: "#404040",
              }}
            >

              {array7.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}
            </nav>

              {array8.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}

              <p className="sideBarTitle sidebar-title">Orders</p>
              {array9.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}

              {/* <p className="navTitle">Product Request</p>
              {array8.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      navIcon={res?.navIcon}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && (
                        <ul className={`subMenu`}>
                          <span className="subhead">{res?.name}</span>
                          {res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })}
                        </ul>
                      )}
                    </Navigator>
                  </>
                );
              })} */}
              <p className="sideBarTitle sidebar-title">Bookings</p>
              {array6.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}

              <p className="sideBarTitle sidebar-title">Finance</p>
              {array4.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      path2={res?.path2}
                      activeArrList={res?.activeArrList}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}

              {array10.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}

              <p className="sideBarTitle sidebar-title">Report</p>
              {array5.map((res, i) => {
                return (
                  <>
                    <Navigator
                      name={res?.name}
                      path={res?.path}
                      activeArrList={res?.activeArrList}
                      path2={res?.path2}
                      navIcon={res?.navIcon}
                      navIconImg={res?.navIconImg}
                      navSVG={res?.navSVG}
                      onClick={res?.onClick && res?.onClick}
                    >
                      {res?.subMenu && res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                name={subMenu.subName}
                                path={subMenu.subPath}
                                onClick={subMenu.onClick}
                              />
                            );
                          })
                      }
                    </Navigator>
                  </>
                );
              })}
            
        </div>
      </div>
    </div>
    </>
  );
};

export default Sidebar;

export const SideMenuJS = (props) => {
  useEffect(() => {
    const handleClick = (event) => {
      const target = $(event.currentTarget);
      const submenu = target.next(".subMenu");

      $(".subMenu").not(submenu).slideUp();
      submenu.slideToggle();

      // Toggle rotation class on the clicked icon
      target.children("svg").toggleClass("rotate90");

      // Remove rotation class from other icons
      $(".mainMenu > li > a > svg")
        .not(target.children("svg"))
        .removeClass("rotate90");
    };

    const handleToggle = () => {
      $(".mainNavbar").toggleClass("mobNav webNav");
      $(".sideBar").toggleClass("mobSidebar webSidebar");

      $(".mainAdmin").toggleClass("mobAdmin");
      $(".fa-angle-right").toggleClass("rotated toggleIcon");
      $(".expand ").toggleClass("rotated toggleIcon");
      $(".comShow").toggleClass("mobCom webCom");

      $(".sideBarTitle").toggleClass("hidden");
      $(".sideBarLogo a").toggleClass("justify-content-center");

      var checkClass = $(".sideBar").hasClass("mobSidebar");
      if (checkClass) {
        var mobSidebarBg = document.querySelector(".mobSidebar-bg");
        mobSidebarBg.classList.add("responsive-bg");
      } else {
        $(".mobSidebar-bg").removeClass("responsive-bg");
      }
    };

    $(".subMenu").hide();
    $(".mainMenu > li > a").on("click", handleClick);
    $(".navToggle").on("click", handleToggle);

    return () => {
      $(".mainMenu > li > a").off("click", handleClick);
      $(".navToggle").off("click", handleToggle);
    };
  }, [props.totalPage]);

  return null;
};
